// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.map.from.js
// module id = 340
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11